import { channelPartnerRequestQueryKeys as e } from "./useChannelPartnerRequestQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminChannelPartnerRequestsApi as n } from "@maat/api-main";
//#region src/channelPartnerRequests/useChannelPartnerRequestQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.detail(r),
	queryFn: () => n.get(r),
	enabled: i && !!r,
	staleTime: Infinity,
	refetchOnWindowFocus: !1,
	refetchOnReconnect: !1
});
//#endregion
export { r as useChannelPartnerRequestQuery };
